<oph-page-header
  [title]="'Roles'"
  [description]="'Manage your roles'"
  [primaryActionButtonText]="'Add Role'"
  [primaryActionButtonIcon]="'plus-white'"
  (primaryActionButtonChange)="addRole()"
  (searchInputChange)="onSearchChange($event)"
/>
